interface Props extends React.SVGAttributes<SVGElement> {
  name: IIcons;
  color?: string;
  width?: string;
  height?: string;
  className?: string;
}

export type IIcons =
  | "left-panel-close"
  | "loading"
  | "import"
  | "calendar"
  | "close"
  | "search"
  | "event-filled"
  | "more"
  | "checkbox"
  | "checkbox-uncheck"
  | "chevron-down"
  | "check"
  | "pdf"
  | "swap_vert"
  | "sort-alphabet"
  | "sort-alphabet-desc"
  | "sort-alphabet-asc"
  | "plane"
  | "radio"
  | "radio-uncheck"
  | "home"
  | "edit"
  | "delete"
  | "pencil"
  | "trash"
  | "arrow-right"
  | "arrow-left";

export const Icon = ({
  name,
  width = "32",
  height = "32",
  color = "#919EAB", // change default color here
  className,
  ...rest
}: Props): React.ReactNode => {
  switch (name) {
    case "left-panel-close":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_3727_13896"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_3727_13896)">
            <path
              d="M16.5 16V8L12.5 12L16.5 16ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM8 19V5H5V19H8ZM10 19H19V5H10V19Z"
              fill="white"
            />
          </g>
        </svg>
      );

    case "pencil":
      return (
        <svg
          width={width}
          height={height}
          color={color}
          className={className}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_2151_41263)">
            <path
              d="M3 17.2501V21.0001H6.75L17.81 9.94006L14.06 6.19006L3 17.2501ZM20.71 7.04006C21.1 6.65006 21.1 6.02006 20.71 5.63006L18.37 3.29006C17.98 2.90006 17.35 2.90006 16.96 3.29006L15.13 5.12006L18.88 8.87006L20.71 7.04006Z"
              fill="#919EAB"
              fill-opacity="0.8"
            />
          </g>
          <defs>
            <clipPath id="clip0_2151_41263">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "loading":
      return (
        <svg
          viewBox="64 64 896 896"
          focusable="false"
          data-icon="sync"
          width={width}
          height={height}
          color={color}
          className={className}
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 01755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8zm756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 01512.1 856a342.24 342.24 0 01-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 00-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 00-8-8.2z"></path>
        </svg>
      );

    case "arrow-right":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.33334 15.8334C8.13863 15.8337 7.94993 15.7659 7.8 15.6417C7.62958 15.5004 7.52238 15.2971 7.50206 15.0767C7.48173 14.8562 7.54996 14.6368 7.69167 14.4667L11.425 10L7.825 5.52504C7.6852 5.35287 7.61978 5.13208 7.64324 4.91155C7.6667 4.69102 7.7771 4.48893 7.95 4.35004C8.12431 4.19667 8.35469 4.12297 8.58565 4.1467C8.81661 4.17043 9.02719 4.28943 9.16667 4.47504L13.1917 9.47504C13.4444 9.78254 13.4444 10.2259 13.1917 10.5334L9.025 15.5334C8.85545 15.7379 8.59853 15.8493 8.33334 15.8334Z"
            fill="#212B36"
          />
        </svg>
      );

    case "arrow-left":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          className={className}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.525 15.8333C11.2728 15.8341 11.0338 15.7207 10.875 15.5249L6.84997 10.5249C6.59721 10.2174 6.59721 9.77409 6.84997 9.46659L11.0166 4.46659C11.3112 4.11221 11.8373 4.0637 12.1916 4.35826C12.546 4.65281 12.5945 5.17887 12.3 5.53326L8.57497 9.99992L12.175 14.4666C12.3831 14.7164 12.4269 15.0643 12.2873 15.3579C12.1476 15.6515 11.85 15.8371 11.525 15.8333Z"
            fill="#212B36"
          />
        </svg>
      );
    case "import":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          className={className}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.33337 15.8333C3.33337 15.3731 3.70647 15 4.16671 15H15.8334C16.2936 15 16.6667 15.3731 16.6667 15.8333C16.6667 16.2936 16.2936 16.6667 15.8334 16.6667H4.16671C3.70647 16.6667 3.33337 16.2936 3.33337 15.8333Z"
            fill={color}
          />
          <path
            d="M4.16671 16.6667C3.70647 16.6667 3.33337 16.2936 3.33337 15.8333V14.1667C3.33337 13.7064 3.70647 13.3333 4.16671 13.3333C4.62694 13.3333 5.00004 13.7064 5.00004 14.1667V15.8333C5.00004 16.2936 4.62694 16.6667 4.16671 16.6667Z"
            fill={color}
          />
          <path
            d="M15.8334 16.6667C15.3731 16.6667 15 16.2936 15 15.8333V14.1667C15 13.7064 15.3731 13.3333 15.8334 13.3333C16.2936 13.3333 16.6667 13.7064 16.6667 14.1667V15.8333C16.6667 16.2936 16.2936 16.6667 15.8334 16.6667Z"
            fill={color}
          />
          <path
            d="M10 12.5C9.82728 12.5013 9.65837 12.4489 9.51671 12.35L6.18337 10C5.80936 9.73468 5.71999 9.21704 5.98337 8.84167C6.11094 8.65963 6.30594 8.53609 6.52503 8.49854C6.74412 8.46098 6.96913 8.51251 7.15004 8.64167L10 10.6333L12.8334 8.5C13.2016 8.22386 13.7239 8.29848 14 8.66667C14.2762 9.03486 14.2016 9.55719 13.8334 9.83333L10.5 12.3333C10.3558 12.4415 10.1803 12.5 10 12.5Z"
            fill={color}
          />
          <path
            d="M10 10.8333C9.5398 10.8333 9.16671 10.4602 9.16671 10V3.33333C9.16671 2.8731 9.5398 2.5 10 2.5C10.4603 2.5 10.8334 2.8731 10.8334 3.33333V10C10.8334 10.4602 10.4603 10.8333 10 10.8333Z"
            fill={color}
          />
        </svg>
      );

    case "calendar":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
        >
          <mask
            id="mask0_3498_111060"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_3498_111060)">
            <path
              d="M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM5 20H19V10H5V20ZM5 8H19V6H5V8ZM12 14C11.7167 14 11.4792 13.9042 11.2875 13.7125C11.0958 13.5208 11 13.2833 11 13C11 12.7167 11.0958 12.4792 11.2875 12.2875C11.4792 12.0958 11.7167 12 12 12C12.2833 12 12.5208 12.0958 12.7125 12.2875C12.9042 12.4792 13 12.7167 13 13C13 13.2833 12.9042 13.5208 12.7125 13.7125C12.5208 13.9042 12.2833 14 12 14ZM8 14C7.71667 14 7.47917 13.9042 7.2875 13.7125C7.09583 13.5208 7 13.2833 7 13C7 12.7167 7.09583 12.4792 7.2875 12.2875C7.47917 12.0958 7.71667 12 8 12C8.28333 12 8.52083 12.0958 8.7125 12.2875C8.90417 12.4792 9 12.7167 9 13C9 13.2833 8.90417 13.5208 8.7125 13.7125C8.52083 13.9042 8.28333 14 8 14ZM16 14C15.7167 14 15.4792 13.9042 15.2875 13.7125C15.0958 13.5208 15 13.2833 15 13C15 12.7167 15.0958 12.4792 15.2875 12.2875C15.4792 12.0958 15.7167 12 16 12C16.2833 12 16.5208 12.0958 16.7125 12.2875C16.9042 12.4792 17 12.7167 17 13C17 13.2833 16.9042 13.5208 16.7125 13.7125C16.5208 13.9042 16.2833 14 16 14ZM12 18C11.7167 18 11.4792 17.9042 11.2875 17.7125C11.0958 17.5208 11 17.2833 11 17C11 16.7167 11.0958 16.4792 11.2875 16.2875C11.4792 16.0958 11.7167 16 12 16C12.2833 16 12.5208 16.0958 12.7125 16.2875C12.9042 16.4792 13 16.7167 13 17C13 17.2833 12.9042 17.5208 12.7125 17.7125C12.5208 17.9042 12.2833 18 12 18ZM8 18C7.71667 18 7.47917 17.9042 7.2875 17.7125C7.09583 17.5208 7 17.2833 7 17C7 16.7167 7.09583 16.4792 7.2875 16.2875C7.47917 16.0958 7.71667 16 8 16C8.28333 16 8.52083 16.0958 8.7125 16.2875C8.90417 16.4792 9 16.7167 9 17C9 17.2833 8.90417 17.5208 8.7125 17.7125C8.52083 17.9042 8.28333 18 8 18ZM16 18C15.7167 18 15.4792 17.9042 15.2875 17.7125C15.0958 17.5208 15 17.2833 15 17C15 16.7167 15.0958 16.4792 15.2875 16.2875C15.4792 16.0958 15.7167 16 16 16C16.2833 16 16.5208 16.0958 16.7125 16.2875C16.9042 16.4792 17 16.7167 17 17C17 17.2833 16.9042 17.5208 16.7125 17.7125C16.5208 17.9042 16.2833 18 16 18Z"
              fill="#1C1B1F"
            />
          </g>
        </svg>
      );
    case "sort-alphabet":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
        >
          <g
            //  fix key example: clip-path to clipPath
            clipPath="url(#clip0_5047_89078)"
          >
            <path
              d="M7.16666 5.825L7.16666 11.6667H8.83333L8.83333 5.825L11.3333 5.825L7.99999 2.5L4.66666 5.825H7.16666ZM13 17.5L16.3333 14.175H13.8333L13.8333 8.33333H12.1667V14.175H9.66666L13 17.5Z"
              fill="#919EAB"
              fillOpacity="0.8" // fix key example: clip-path to clipPath
            />
            <path
              d="M13 17.5L16.3333 14.175H13.8333L13.8333 8.33333H12.1667V14.175H9.66666L13 17.5Z"
              fill="#919EAB"
              // fix key example: clip-path to clipPath
              fillOpacity="0.8"
            />
          </g>
          <defs>
            <clipPath id="clip0_5047_89078">
              <rect
                width="20"
                height="20"
                fill="white"
                transform="matrix(-1 0 0 -1 20.5 20)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case "sort-alphabet-desc":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <g
            // fix key example: clip-path to clipPath
            clipPath="url(#clip0_5047_89073)"
          >
            <path
              d="M6.66668 5.825L6.66668 11.6667H8.33334L8.33334 5.825L10.8333 5.825L7.50001 2.5L4.16668 5.825H6.66668ZM12.5 17.5L15.8333 14.175H13.3333L13.3333 8.33333H11.6667V14.175H9.16668L12.5 17.5Z"
              fill="#919EAB"
              // fix key example: clip-path to clipPath
              fillOpacity="0.8"
            />
            <path
              d="M12.5 17.5L15.8333 14.175H13.3333L13.3333 8.33333H11.6667V14.175H9.16668L12.5 17.5Z"
              fill="#212B36"
            />
          </g>
          <defs>
            <clipPath id="clip0_5047_89073">
              <rect
                width="20"
                height="20"
                fill="white"
                transform="matrix(-1 0 0 -1 20 20)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case "sort-alphabet-asc":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <g
            // fix key example: clip-path to clipPath
            clipPath="url(#clip0_5047_89073)"
          >
            <path
              d="M6.66668 5.825L6.66668 11.6667H8.33334L8.33334 5.825L10.8333 5.825L7.50001 2.5L4.16668 5.825H6.66668ZM12.5 17.5L15.8333 14.175H13.3333L13.3333 8.33333H11.6667V14.175H9.16668L12.5 17.5Z"
              fill="#212B36"
              // fix key example: clip-path to clipPath
              fillOpacity="0.8"
            />
            <path
              d="M12.5 17.5L15.8333 14.175H13.3333L13.3333 8.33333H11.6667V14.175H9.16668L12.5 17.5Z"
              fill="#919EAB"
            />
          </g>
          <defs>
            <clipPath id="clip0_5047_89073">
              <rect
                width="20"
                height="20"
                fill="white"
                transform="matrix(-1 0 0 -1 20 20)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case "plane":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clipPath="url(#clip0_2904_50716)">
            <path
              d="M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_2904_50716">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "close":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          {...rest}
        >
          <g
            // fix key example: clip-path to clipPath
            clipPath="url(#clip0_5375_89221)"
          >
            <path
              d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
              fill={color}
            />
          </g>
          <defs>
            <clipPath id="clip0_5375_89221">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case "search":
      return (
        <svg
          width="15"
          height="16"
          viewBox="0 0 15 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...rest}
        >
          <path
            d="M10.4167 9.87956H9.75833L9.525 9.65456C10.3417 8.70456 10.8333 7.47122 10.8333 6.12956C10.8333 3.13789 8.40833 0.712891 5.41667 0.712891C2.425 0.712891 0 3.13789 0 6.12956C0 9.12122 2.425 11.5462 5.41667 11.5462C6.75833 11.5462 7.99167 11.0546 8.94167 10.2379L9.16667 10.4712V11.1296L13.3333 15.2879L14.575 14.0462L10.4167 9.87956ZM5.41667 9.87956C3.34167 9.87956 1.66667 8.20456 1.66667 6.12956C1.66667 4.05456 3.34167 2.37956 5.41667 2.37956C7.49167 2.37956 9.16667 4.05456 9.16667 6.12956C9.16667 8.20456 7.49167 9.87956 5.41667 9.87956Z"
            fill="#637381"
          />
        </svg>
      );

    case "event-filled":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          {...rest}
        >
          <path
            d="M17 12H12V17H17V12ZM16 1V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3H18V1H16ZM19 19H5V8H19V19Z"
            fill="black"
            fillOpacity="0.56"
          />
        </svg>
      );
    case "more":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
          {...rest}
        >
          <g clip-path="url(#clip0_7751_68567)">
            <path
              d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z"
              fill={color}
            />
          </g>
          <defs>
            <clipPath id="clip0_7751_68567">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "checkbox":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          className={className}
          {...rest}
        >
          <g clipPath="url(#clip0_2316_112221)">
            <path
              d="M15.8333 2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.7583 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.7583 2.5 15.8333 2.5ZM8.33333 14.1667L4.16667 10L5.34167 8.825L8.33333 11.8083L14.6583 5.48333L15.8333 6.66667L8.33333 14.1667Z"
              fill="#1E88A8"
            />
          </g>
          <defs>
            <clipPath id="clip0_2316_112221">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "checkbox-uncheck":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          className={className}
          {...rest}
        >
          <g clipPath="url(#clip0_2316_112233)">
            <path
              d="M15.8333 4.16667V15.8333H4.16667V4.16667H15.8333ZM15.8333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5Z"
              fill="#637381"
            />
          </g>
          <defs>
            <clipPath id="clip0_2316_112233">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "chevron-down":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
          {...rest}
        >
          <g clipPath="url(#clip0_2316_112078)">
            <path
              d="M18 9.99984L16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984Z"
              fill="#637381"
            />
          </g>
          <defs>
            <clipPath id="clip0_2316_112078">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="matrix(0 1 -1 0 24 0)"
              />
            </clipPath>
          </defs>
        </svg>
      );

    case "check":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          className={className}
          {...rest}
        >
          <mask
            id="mask0_5091_88736"
            // style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="16"
            height="16"
          >
            <rect width="16" height="16" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_5091_88736)">
            <path
              d="M6.36689 12.0001L2.56689 8.20007L3.51689 7.25007L6.36689 10.1001L12.4836 3.9834L13.4336 4.9334L6.36689 12.0001Z"
              fill="#1E88A8"
            />
          </g>
        </svg>
      );

    case "pdf":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="22"
          viewBox="0 0 19 22"
          fill="none"
          className={className}
          {...rest}
        >
          <g opacity="0.3">
            <path
              opacity="0.3"
              d="M12.8025 4.5144C12.3014 4.51391 11.8209 4.31461 11.4666 3.96026C11.1122 3.6059 10.9129 3.12543 10.9125 2.6243V0H2.46665C1.81245 0 1.18505 0.259885 0.722466 0.722472C0.25988 1.18506 0 1.81244 0 2.46664V17.3362C0.000971476 17.9897 0.261277 18.6162 0.723758 19.078C1.18624 19.5398 1.81308 19.7992 2.46665 19.7992H12.6055C13.259 19.7992 13.8859 19.5398 14.3484 19.078C14.8108 18.6162 15.0712 17.9897 15.0721 17.3362V4.5144H12.8025Z"
              fill="#FF3E4C"
            />
          </g>
          <path
            d="M15.0723 4.5144H12.8027C12.3016 4.51391 11.8211 4.31461 11.4667 3.96026C11.1124 3.6059 10.9131 3.12543 10.9126 2.6243V0L15.0723 4.5144Z"
            fill="#FF3E4C"
          />
          <path
            d="M11.9711 13.8264H2.5078C2.41663 13.8264 2.3292 13.7902 2.26474 13.7258C2.20028 13.6613 2.16406 13.5739 2.16406 13.4827C2.16431 13.3917 2.20063 13.3045 2.26506 13.2402C2.3295 13.176 2.41679 13.1399 2.5078 13.1399H11.9711C12.062 13.1399 12.1492 13.176 12.2135 13.2403C12.2778 13.3046 12.3139 13.3918 12.3139 13.4827C12.314 13.5278 12.3052 13.5725 12.2881 13.6142C12.2709 13.6559 12.2457 13.6938 12.2138 13.7257C12.182 13.7576 12.1441 13.783 12.1025 13.8003C12.0608 13.8175 12.0162 13.8264 11.9711 13.8264Z"
            fill="#FF3E4C"
          />
          <path
            d="M11.9711 9.95462H2.5078C2.41679 9.95462 2.3295 9.91852 2.26506 9.85425C2.20063 9.78999 2.16431 9.70281 2.16406 9.6118C2.16406 9.52064 2.20028 9.43319 2.26474 9.36873C2.3292 9.30426 2.41663 9.26807 2.5078 9.26807H11.9711C12.0162 9.26807 12.0608 9.27696 12.1025 9.29425C12.1441 9.31153 12.182 9.33686 12.2138 9.36879C12.2457 9.40072 12.2709 9.43863 12.2881 9.48033C12.3052 9.52203 12.314 9.56671 12.3139 9.6118C12.3139 9.70272 12.2778 9.78992 12.2135 9.85421C12.1492 9.9185 12.062 9.95462 11.9711 9.95462Z"
            fill="#FF3E4C"
          />
          <path
            d="M11.9711 11.8905H2.5078C2.41663 11.8905 2.3292 11.8543 2.26474 11.7899C2.20028 11.7254 2.16406 11.638 2.16406 11.5468C2.16431 11.4558 2.20063 11.3686 2.26506 11.3043C2.3295 11.2401 2.41679 11.204 2.5078 11.204H11.9711C12.062 11.204 12.1492 11.2401 12.2135 11.3044C12.2778 11.3687 12.3139 11.4559 12.3139 11.5468C12.314 11.5919 12.3052 11.6366 12.2881 11.6783C12.2709 11.72 12.2457 11.7579 12.2138 11.7898C12.182 11.8217 12.1441 11.8471 12.1025 11.8644C12.0608 11.8816 12.0162 11.8905 11.9711 11.8905Z"
            fill="#FF3E4C"
          />
          <path
            d="M8.23856 8.01865H2.5078C2.41679 8.01865 2.3295 7.98257 2.26506 7.9183C2.20063 7.85404 2.16431 7.76683 2.16406 7.67583C2.16406 7.58466 2.20028 7.49724 2.26474 7.43277C2.3292 7.36831 2.41663 7.33209 2.5078 7.33209H8.23856C8.32957 7.33233 8.41676 7.36865 8.48103 7.43309C8.54529 7.49752 8.58138 7.58482 8.58138 7.67583C8.58114 7.76667 8.54494 7.85373 8.4807 7.91796C8.41647 7.9822 8.32941 8.0184 8.23856 8.01865Z"
            fill="#FF3E4C"
          />
          <path
            d="M8.23856 6.08273H2.5078C2.41679 6.08273 2.3295 6.04663 2.26506 5.98236C2.20063 5.9181 2.16431 5.83092 2.16406 5.73991C2.16406 5.64875 2.20028 5.5613 2.26474 5.49684C2.3292 5.43238 2.41663 5.39618 2.5078 5.39618H8.23856C8.32957 5.39642 8.41676 5.43274 8.48103 5.49717C8.54529 5.56161 8.58138 5.64891 8.58138 5.73991C8.58114 5.83076 8.54494 5.91781 8.4807 5.98205C8.41647 6.04629 8.32941 6.08249 8.23856 6.08273Z"
            fill="#FF3E4C"
          />
          <path
            d="M16.8604 15.6386H5.39886C4.58584 15.6386 3.92676 16.2977 3.92676 17.1107V20.5279C3.92676 21.3409 4.58584 22 5.39886 22H16.8604C17.6734 22 18.3325 21.3409 18.3325 20.5279V17.1107C18.3325 16.2977 17.6734 15.6386 16.8604 15.6386Z"
            fill="#FF3E4C"
          />
          <path
            d="M7.68687 19.559V20.2254H6.99756V19.559H7.68687Z"
            fill="white"
          />
          <path
            d="M8.70057 19.2584V20.2254H8.03418V17.4691H9.11397C9.44121 17.4691 9.69145 17.5507 9.86285 17.7129C9.94959 17.7982 10.0173 17.9008 10.0615 18.0141C10.1058 18.1273 10.1255 18.2487 10.1195 18.3701C10.1228 18.5304 10.0833 18.6886 10.0049 18.8285C9.92491 18.9652 9.80628 19.0752 9.66395 19.1447C9.49226 19.2259 9.30378 19.2651 9.11397 19.2593L8.70057 19.2584ZM9.44121 18.3701C9.44121 18.1257 9.30738 18.0035 9.03972 18.0035H8.70057V18.7212H9.03972C9.30738 18.7237 9.44121 18.6066 9.44121 18.3701Z"
            fill="white"
          />
          <path
            d="M12.7531 19.5609C12.6383 19.7693 12.4649 19.9395 12.2544 20.0504C12.0176 20.1716 11.7542 20.2318 11.4881 20.2254H10.4478V17.4691H11.4881C11.7544 17.4624 12.0181 17.5213 12.2563 17.6405C12.4662 17.749 12.6391 17.9175 12.7531 18.1245C12.8723 18.3443 12.9324 18.5913 12.9272 18.8413C12.9322 19.0922 12.8722 19.3401 12.7531 19.5609ZM12.0363 19.4225C12.1108 19.346 12.1685 19.2548 12.2058 19.1547C12.243 19.0547 12.259 18.9479 12.2526 18.8413C12.259 18.7349 12.2431 18.6282 12.2058 18.5283C12.1686 18.4284 12.1108 18.3374 12.0363 18.2611C11.8696 18.1148 11.6518 18.0403 11.4304 18.0539H11.1141V19.6287H11.4304C11.6516 19.6421 11.8692 19.5681 12.0363 19.4225Z"
            fill="white"
          />
          <path
            d="M15.1022 17.4691V17.9998H13.972V18.6039H14.8446V19.1108H13.972V20.2254H13.3047V17.4691H15.1022Z"
            fill="white"
          />
          <path
            d="M11.8035 5.39618H10.1829C9.90038 5.39618 9.67139 5.62518 9.67139 5.90766V7.52826C9.67139 7.81074 9.90038 8.03974 10.1829 8.03974H11.8035C12.0859 8.03974 12.3149 7.81074 12.3149 7.52826V5.90766C12.3149 5.62518 12.0859 5.39618 11.8035 5.39618Z"
            fill="#FF3E4C"
          />
        </svg>
      );

    case "swap_vert":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
          className={className}
          {...rest}
        >
          <g clipPath="url(#clip0_6044_14920)">
            <path
              d="M12.1992 12.7575V7.5H10.6992V12.7575H8.44922L11.4492 15.75L14.4492 12.7575H12.1992ZM6.94922 2.25L3.94922 5.2425H6.19922V10.5H7.69922V5.2425H9.94922L6.94922 2.25Z"
              fill="#637381"
            />
          </g>
          <defs>
            <clipPath id="clip0_6044_14920">
              <rect
                width="18"
                height="18"
                fill="white"
                transform="translate(0.199219)"
              />
            </clipPath>
          </defs>
        </svg>
      );

    case "radio-uncheck":
      return (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          {...rest}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.66667 18.0003C9.66667 22.6027 13.3976 26.3337 18 26.3337C22.6024 26.3337 26.3333 22.6027 26.3333 18.0003C26.3333 13.398 22.6024 9.66699 18 9.66699C13.3976 9.66699 9.66667 13.398 9.66667 18.0003ZM10.9167 18.0003C10.9167 14.0883 14.088 10.917 18 10.917C21.912 10.917 25.0833 14.0883 25.0833 18.0003C25.0833 21.9123 21.912 25.0837 18 25.0837C14.088 25.0837 10.9167 21.9123 10.9167 18.0003Z"
            fill="#637381"
          />
        </svg>
      );

    case "radio":
      return (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          {...rest}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.66666 18.0003C9.66666 13.398 13.3976 9.66699 18 9.66699C20.2101 9.66699 22.3298 10.545 23.8926 12.1078C25.4554 13.6706 26.3333 15.7902 26.3333 18.0003C26.3333 22.6027 22.6024 26.3337 18 26.3337C13.3976 26.3337 9.66666 22.6027 9.66666 18.0003ZM10.9167 18.0003C10.9167 21.9123 14.088 25.0837 18 25.0837C19.8786 25.0837 21.6803 24.3374 23.0087 23.009C24.3371 21.6806 25.0833 19.8789 25.0833 18.0003C25.0833 14.0883 21.912 10.917 18 10.917C14.088 10.917 10.9167 14.0883 10.9167 18.0003Z"
            fill="#1E88A8"
          />
          <path
            d="M18 13.8337C15.6988 13.8337 13.8333 15.6991 13.8333 18.0003C13.8333 20.3015 15.6988 22.167 18 22.167C20.3012 22.167 22.1667 20.3015 22.1667 18.0003C22.1667 15.6991 20.3012 13.8337 18 13.8337Z"
            fill="#1E88A8"
          />
        </svg>
      );

    case "home":
      return (
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          {...rest}
        >
          <mask
            id="mask0_2904_50671"
            // style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="25"
            height="24"
          >
            <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_2904_50671)">
            <path
              d="M6.5 19H9.5V13H15.5V19H18.5V10L12.5 5.5L6.5 10V19ZM4.5 21V9L12.5 3L20.5 9V21H13.5V15H11.5V21H4.5Z"
              fill="white"
            />
          </g>
        </svg>
      );

    case "edit":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
          {...rest}
        >
          <g clipPath="url(#clip0_6892_44085)">
            <path
              d="M3 17.2496V20.9996H6.75L17.81 9.93957L14.06 6.18957L3 17.2496ZM20.71 7.03957C21.1 6.64957 21.1 6.01957 20.71 5.62957L18.37 3.28957C17.98 2.89957 17.35 2.89957 16.96 3.28957L15.13 5.11957L18.88 8.86957L20.71 7.03957Z"
              fill={color}
              fillOpacity="0.8"
            />
          </g>
          <defs>
            <clipPath id="clip0_6892_44085">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case "delete":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
          {...rest}
        >
          <g clipPath="url(#clip0_6892_44088)">
            <path
              d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z"
              fill={color}
              fillOpacity="0.8"
            />
          </g>
          <defs>
            <clipPath id="clip0_6892_44088">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    default:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_2151_41263)">
            <path
              d="M3 17.2501V21.0001H6.75L17.81 9.94006L14.06 6.19006L3 17.2501ZM20.71 7.04006C21.1 6.65006 21.1 6.02006 20.71 5.63006L18.37 3.29006C17.98 2.90006 17.35 2.90006 16.96 3.29006L15.13 5.12006L18.88 8.87006L20.71 7.04006Z"
              fill="#919EAB"
              fill-opacity="0.8"
            />
          </g>
          <defs>
            <clipPath id="clip0_2151_41263">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
  }
};
